import * as HttpDataServiceBase from '../core/httpdataservicebase';
import * as Model from '../models/models';
import IAppSettings from '../../iApp.settings';
import * as MessageBarService from '../core/services/messageBarService/messageBar.service';
import * as LogService from '../core/services/logservice/log.service';

export class SubmissionRequestRepository extends HttpDataServiceBase.DataServiceBase<Model.ISubmissionRequest> {
    private appSettings: IAppSettings;

    public static $inject = ['$q', '$http', 'logService', 'appSettings', 'messageBarService'];
    constructor($q: ng.IQService, $http: ng.IHttpService, logger: LogService.ILogService, appSettings: any, messageBarService: MessageBarService.MessageBarService) {
        super($q, $http, logger, messageBarService, appSettings.apiPath + '/submissionrequests');
        this.appSettings = appSettings;
    }
}